import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_WALLET_IMPORT_QUERY_KEY = "bot-wallet-import";

type BotWalletImportParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
  privateKey: string;
};

type BotWalletImportResponse = {
  walletImported: { address: string };
};

const postBotWalletImport = async (
  api: Api,
  params: BotWalletImportParams,
): Promise<BotWalletImportResponse> =>
  api.post("wallet/import", { json: params }).json();

const useBotWalletImportMutation = () =>
  useMutation({
    mutationFn: async (params: BotWalletImportParams) =>
      postBotWalletImport(api, params),
    mutationKey: [BOT_WALLET_IMPORT_QUERY_KEY],
  });

export {
  useBotWalletImportMutation,
  postBotWalletImport,
  BOT_WALLET_IMPORT_QUERY_KEY,
};
